import React from 'react'

import './Products.scss'

const ProductL = (props) => {
  return (
    <div className="product__details">
        <img src={props.image} alt="Image" />
        <div className="product_details">
            <h2 className='section__subheading'>{props.heading}</h2>
            <article>{props.description}</article>
            <a href={props.buttonRef} className='btn product__actionbtn'>{props.buttonText}</a>
        </div>
    </div>
  )
}

export default ProductL